import {texture} from "p3";
import {iswebfont} from "../../utils";

export default class LocationButton extends P3.Button {
    /**
     * @param {string} location
     */
    constructor(location) {
        super(new P3.ButtonStates(PIXI.Texture.EMPTY));

        this._location = location;

        const tex = texture("btn_location_unlocked");
        this._frame = new PIXI.NineSlicePlane(tex, 40, 25, 40, 25);
        this.animation.addChild(this._frame);

        if (!iswebfont()) {
            this._label = new PIXI.BitmapText(location, {
                fontName: "Alghera Pro",
                fontSize: 20,
                align: "center",
                tint: 0x0,
                maxWidth: 150
            });
        } else {
            this._label = new PIXI.Text(location, {
                fontFamily: "FredFredBurger",
                fontSize: 20,
                align: "center",
                fill: 0x0,
                wordWrap: true,
                wordWrapWidth: 150
            });
        }
        this._label.position.set(0, 0);
        this._label.anchor.set(0.5, 1);
        this.animation.addChild(this._label);

        if (!iswebfont()) {
            this._frame.width = Math.max(110, this._label.textWidth * 1.35);
            this._frame.height = this._label.textHeight + this._frame.topHeight;
        } else {
            this._frame.width = Math.max(110, this._label.width * 1.35);
            this._frame.height = this._label.height + this._frame.topHeight;
        }
        this._frame.x = - this._frame.width/2;
        this._frame.y = - this._frame.height;
        this._label.y = - this._frame.bottomHeight/2;

        if (iswebfont()) {
            this._label.y -= 2;
        }

        //this.animation.pivot.y = this._frame.height;

        this._tail = new PIXI.Sprite(texture("btn_location_triangle_unlocked"));
        this._tail.anchor.set(0.5, 0);
        this._tail.y = -17;
        this.animation.addChild(this._tail);
    }

    /**
     * @return {string}
     */
    get location() {
        return this._location;
    }
}